import { Component, OnInit, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { HomeService } from '../../../pages/home/services/home.service';

@Component({
  selector: 'app-clockout-modal',
  templateUrl: './clockout-modal.component.html',
  styleUrls: ['./clockout-modal.component.css'],
})
export class ClockoutModalComponent implements OnInit {
  @ViewChild('signaturePad', { static: false }) signaturePad;

  portalSettings: any;
  formData: { [key: string]: any } = {};
  userAction: any;
  customMsg: any;
  rawImgData: any;
  submitSignImg: any = null;
  hideClick: boolean;
  showClickMsg: boolean;
  requireSign = true;
  signatureNEmpty: boolean;
  redBorder: boolean;
  panelWidth: number;
  signaturePadOptions: Object = {
    canvasWidth: 430,
    canvasHeight: 150,
  };

  constructor(
    private homeService: HomeService,
    private bsModalRef: BsModalRef
  ) {
    this.homeService = homeService;
  }

  ngOnInit(): void {
    this.formData.typeSign = false;
    this.customMsg = this.portalSettings.CustomVerbiageClockOutSign.ConfigValue;
    var width = $('#modal_size').width();
    this.panelWidth = (width > 550 ? 550 : width) + 30;
  }

  clockOutClicked() {
    this.checkSigned();
    if (this.formData.typeSign) {
      this.userAction = this.rawImgData;
      this.bsModalRef.hide();
    } else if (this.signatureNEmpty) {
      this.userAction = this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, '');
      this.bsModalRef.hide();
    }
  }

  cancelClicked() {
    this.userAction = 'close';
    this.bsModalRef.hide();
  }

  clickSign(type: string) {
    if (this.signaturePad.isEmpty()) {
      this.formData.typeSign = true;
      this.homeService.getTypeSign(type).then((response: any) => {
        this.rawImgData = response;
        this.submitSignImg = 'data:image/png;base64,' + response;
      });
      this.hideClick = true;
      this.showClickMsg = false;
    } else {
      this.showClickMsg = true;
    }
  }

  checkSigned() {
    if (this.signaturePad.isEmpty()) {
      this.redBorder = true;
    } else {
      this.signatureNEmpty = true;
      this.redBorder = false;
    }
  }

  clear() {
    if (this.signaturePad != null) {
      this.signaturePad.clear();
    }
    this.signatureNEmpty = false;
    this.rawImgData = null;
    this.submitSignImg = null;
    this.formData.typeSign = false;
    this.showClickMsg = false;
    this.hideClick = false;
  }
}
